export function getFullName(...args: (string | null | undefined)[]) {
    return args
        .map((arg) => arg || "unknown")
        .join(" ")
        .trim();
}
